<template>
  <div
    class="mx-auto pt-6 pb-3"
    :style="{
      maxWidth: $vuetify.breakpoint.mobile ? '100%' : '1161px',
    }"
  >
    <!-- Date Picker -->
    <v-card
      class="mb-6"
      :style="{
        'border-radius': '10px',
        background: $vuetify.theme.dark ? '#252525' : ''
      }"
    >
      <v-row class="px-4 pt-4">
        <!-- DateStart -->
        <v-col cols="12" md="6" sm="6">
          <v-menu
            v-model="menuStart"
            :close-on-content-click="false"
            transition="scale-transition"
            min-width="200"
            class=""
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedDateFormattedStart"
                outlined
                :label="$t('dateStart')"
                prepend-icon="mdi-calendar"
                readonly
                hide-details="auto"
                class=""
                v-on="on"
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateStart"
              @input="menuStart = false"
              :min="userRegisterDate"
              :max="dateGetTimezoneOffset"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <!-- Datefinal -->
        <v-col cols="12" md="6" sm="6">
          <v-menu
            v-model="menuFinal"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="200"
            class=""
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedDateFormattedFinal"
                outlined
                :label="$t('dateFinal')"
                prepend-icon="mdi-calendar"
                readonly
                hide-details="auto"
                class=""
                v-on="on"
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateFinal"
              @input="menuFinal = false"
              :min="dateStart"
              :max="dateGetTimezoneOffset"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-card-actions class="d-flex justify-end px-4 pb-4">
        <v-tooltip
          top
          content-class="maxWidth"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              class="mr-3"
            >
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{ $t("rangeDateInfo") }}</span>
        </v-tooltip>
        <!-- <v-spacer></v-spacer> -->
        <v-btn
          class="white black--text"
          small
          @click="clearInputDate()"
        >
          {{ $t("toClean") }}
        </v-btn>
        <v-btn
          class="info"
          small
          :loading="progress"
          :disabled="!setApplyFilter || progress || !dateStartIsBeforeDateFinal"
          @click="applyFilter()"
        >
          <v-icon small left>mdi-filter</v-icon>
          {{ $t("applyFilter") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- <v-alert
      v-if="errorMsg && !progress"
      dense
      color="#DC5E1833"
      class="d-flex justify-center mx-auto mb-11"
      :style="{
        'font-size': '14px',
        width: $vuetify.breakpoint.mobile ? '80%' : '50%',
      }"
    >
      <div
        class="d-flex text-center align-center"
        :class="$vuetify.breakpoint.mobile && 'flex-column'"
      >
        <v-icon
          color="#DC5E18"
          :style="{
            'margin-right': $vuetify.breakpoint.mobile ? '' : '22px',
          }"
        >
          mdi-alert
        </v-icon>
        {{ errorMsg }}
      </div>
    </v-alert> -->

    <!-- <div v-show="progress && !analyticsReportData" class="text-center pa-4">
      <v-progress-circular indeterminate></v-progress-circular>
    </div> -->

    <!-- <div v-if="!errorMsg && !progress && analyticsReportData"> -->
    <div>
      <div class="d-flex align-center mb-6" style="font-size: 20px">
        {{ $t("transactions") }}
        <v-divider class="ml-2"></v-divider>
      </div>

      <AnalyticalReportCard
        :type="['depositQty', 'withdrawQty']"
        :amounts="[
          analyticsReportData && analyticsReportData.quantity_deposit,
          analyticsReportData && analyticsReportData.quantity_withdraw,
        ]"
      />

      <AnalyticalReportCard
        :type="['deposit', 'withdraw']"
        :values="[
          analyticsReportData && analyticsReportData.value_deposit,
          analyticsReportData && analyticsReportData.value_withdraw,
        ]"
        :marginBottom="false"
      />

      <div class="d-flex align-center mb-6" style="font-size: 20px">
        {{ $t("sports") }}
        <v-divider class="ml-2"></v-divider>
      </div>

      <AnalyticalReportCard
        :type="['betsQty', 'betsPrizeQty']"
        :amounts="[
          analyticsReportData && analyticsReportData.quantity_bet,
          analyticsReportData && analyticsReportData.quantity_prizes,
        ]"
      />

      <AnalyticalReportCard
        :type="['bets', 'betsPrize']"
        :values="[
          analyticsReportData && analyticsReportData.value_bet,
          analyticsReportData && analyticsReportData.value_prizes,
        ]"
        :marginBottom="true"
      />

      <div
        v-if="hasCasino"
        class="d-flex align-center mb-6"
        style="font-size: 20px"
      >
        {{ $t("casino") }}
        <v-divider class="ml-2"></v-divider>
      </div>

      <AnalyticalReportCard
        v-if="hasCasino"
        :type="['betCasinoQty', 'prizesCasinoQty']"
        :amounts="[
          analyticsReportData && analyticsReportData.quantity_bet_casino,
          analyticsReportData && analyticsReportData.quantity_prize_casino,
        ]"
      />

      <AnalyticalReportCard
        v-if="hasCasino"
        :type="['betCasino', 'prizesCasino']"
        :values="[
          analyticsReportData && analyticsReportData.value_bet_casino,
          analyticsReportData && analyticsReportData.value_prizes_casino,
        ]"
      />
    </div>
  </div>
</template>

<script>
import AnalyticalReportCard from "../../affiliates/users/affiliates/AnalyticalReportCard.vue";
export default {
  name: "analytical-report-player",
  components: { AnalyticalReportCard },
  props: ["userId"],
  data: () => ({
    analyticsReportData: null,
    progress: false,
    errorMsg: null,

    // Date Picker
    menuStart: "",
    dateStart: "",
    timeStart: "",
    menuFinal: "",
    dateFinal: "",
    timeFinal: "",
    hideDetailsStart: true,
    errorTimeStart: "",
    hideDetailsFinal: true,
    errorTimeFinal: "",
    userRegisterDate: "",
    minStartDate: null,
    routeName: "",
  }),

  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },

    rangeDate() {
      return this.$store.state.range.date;
    },

    saveFilters() {
      return this.$store.state.filters.save;
    },

    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },

    hasCasino() {
      if (this.analyticsReportData) {
        const casinoValues = Object.entries(
          this.analyticsReportData
        ).filter((item) => item[0].includes("casino"));
        return casinoValues.find((value) => value[1] > 0);
      }
      return false;
    },

    dateGetTimezoneOffset() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substring(0, 10);
    },

    computedDateFormattedStart() {
      return this.dateStart && this.$handleDate(this.dateStart).date;
    },

    computedDateFormattedFinal() {
      return this.dateFinal && this.$handleDate(this.dateFinal).date;
    },

    setApplyFilter() {
      return this.dateStart != "" && this.dateFinal != "";
    },

    dateStartIsBeforeDateFinal() {
      if (this.dateStart && this.dateFinal) {
        return this.dateStart < this.dateFinal || this.dateStart == this.dateFinal;
      }
      return ""
    },
    autoCompleteUserId() {
      return this.$store.state.filters.autocompletePlayers.id;
    }
  },

  created() {
    this.fetchAnalyticsDataByPlayer();
    this.routeName = this.$route.name;
  },

  watch: {
    dateStartIsBeforeDateFinal(val) {
      if (this.dateStart == "" || this.dateFinal == "") return;
      if (!val) {
        this.$store.commit("setFeedbackSnack", {
         msg: this.$t("dateStartBeforeDateFinal"),
         color: "warning"
       })
      } else {
        return true;
      }
    },

    setApplyFilter(val) {
      !val && this.fetchAnalyticsDataByPlayer();
    },

    // Tratando data minima inicial do date start
    userRegisterDate(val) {
      if (val != "") {
        this.minStartDate = val
      } else {
        this.minStartDate = this.dateGetTimezoneOffset;
      }
    },

    saveFilters(val) {
      if (
        this.$route.name === "AdministratorAnalyticalReportPlayer" ||
        this.$route.name === "CollaboratorAnalyticalReportPlayer"
      ) {
        // this.progress = true;
        val && this.fetchAnalyticsDataByPlayer();
        // if (this.exportDoc != "") {
        //   this.progress = false;
        // }
      }
    },

    autoCompleteUserId(val, oldVal) {
      if (oldVal) {
        this.clearInputDate();
      }
    },
  },

  methods: {
    applyFilter() {
      this.fetchAnalyticsDataByPlayer();
    },

    async fetchAnalyticsDataByPlayer() {
      this.$store.commit("setFeedbackProgress", true);
      this.progress = true;

      const dateStart = this.dateStart && `${this.dateStart} 00:00:00`;
      const dateFinal = this.dateFinal && `${this.dateFinal} 23:59:59`;
      const rangeDate = {
        data_inicio: dateStart,
        data_final: dateFinal
      }

      const body = {
        date_start: dateStart,
        date_final: dateFinal,
        id_user: this.userId,
        export: this.exportDoc,
      };

      const isCollaborator = JSON.parse(localStorage.getItem("user_data"))
        .isCollaborator;

      const endpoint = isCollaborator ? "colab" : "administrator";

      if (this.exportDoc) {
        const extension = this.exportDoc;
        try {
          await this.$request
            .exportDoc(
              `/${endpoint}/players/playerAnalyticsData`,
              body,
              extension,
              dateStart != "" && dateFinal != "" && rangeDate,
            )
            .then(() => (this.errorMsg = null));
        } catch (err) {
          this.errorMsg = this.$t("noDataFount");
        } finally {
          this.progress = false;
        }
      } else {
        await this.$axios
          .post(
            `/${endpoint}/players/playerAnalyticsData`,
            this.$formdata(body)
          )
          .then((res) => {
            this.errorMsg = res.data.dados && null;
            this.analyticsReportData = res.data.dados;

            this.userRegisterDate = res.data.player.data_cadastro;
          })
          .catch((err) => {
            this.errorMsg = err.response.data.messages.error;
          })
          .finally(() => (this.progress = false));
      }
    },

    // formatDate(date) {
    //   if (!date) return null;
    //   const [year, month, day] = date.split("-");
    //   return `${day}/${month}/${year}`;
    // },

    clearInputDate() {
      this.dateStart = "";
      this.dateFinal = "";
    },
  },
};
</script>

<style scoped>
.maxWidth {
  max-width: 300px;
}
</style>